import React from 'react';
import {
    Switch,
    Route,
    Redirect
} from "react-router-dom";

//pages import
import Scan from './scan/Scan';
import Groups from './groups/Groups';
import Account from './account/Account';
import Error from './error/Error';
import Settings from './settings/Settings';
import Home from './home/Home';
import InsertExpense from './insert-expense/InsertExpense';
import CreateEditGroup from './create-edit-group/CreateEditGroup';
import Expenses from './expenses/Expenses';
import SignIn from './sign-in/SignIn';
import SignUp from './sign-up/SignUp';
import ManagePeople from './manegePeople/ManagePeople';
import ExpeseDetails from './detailExpense/ExpenseDetails';

const Pages = () => {
    return(
            <div>
                <Switch>
                    <Route path = "/home" component = {Home} />
                    <Route path = "/groups" component = {Groups} />
                    <Route exact path="/scan/:groupId/:expenseId" component= {Scan} />
                    <Route path = "/account" component = {Account} />
                    <Route path = "/settings" component = {Settings} />
                    <Route path = "/insertExpense/:groupId/:expenseId" component = {InsertExpense} />
                    <Route path = "/createEditGroup/:groupId" component = {CreateEditGroup} />
                    <Route path = "/expenses/:groupId" component = {Expenses} />
                    <Route path = "/signIn" component = {SignIn} />
                    <Route path = "/signUp" component = {SignUp} />
                    <Route path = "/managePeople/:groupId" component = {ManagePeople} />
                    <Route path = "/expenseDetail/:groupId/:expenseId" component = {ExpeseDetails} />
                    <Route exact path="/">
                        <Redirect to="/home" />
                    </Route>
                    <Route component={Error}/>
                </Switch>
            </div>
    );
};

export default Pages;